import { lazy } from "react";

const create = lazy(() => import("./Create").then(m => ({ default: m.PersonEducationCreate })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.PersonEducationEdit })));

export default {
  create,
  edit,
  options: { label: "Person Education" },
};
